import { useQuery } from '@apollo/client';
import { FETCH_POLICY } from 'common/apollo/FETCH_POLICY';
import { GET_ALL_JOB_FAMILY_DATA, UseGetAllJobFamilyData } from './jobFamily.graphql';

const ALL_FAMILIES = 10000;
const NO_OFFSET = 0;

export const useGetAllJobFamilyData = () => {
  const { data: fullData, loading: gettingFullData } = useQuery<
    UseGetAllJobFamilyData,
    { search?: string; limit: number; offset: number }
  >(GET_ALL_JOB_FAMILY_DATA, {
    fetchPolicy: FETCH_POLICY.CACHE_FIRST,
    variables: { limit: ALL_FAMILIES, offset: NO_OFFSET }
  });

  return { fullData, gettingFullData };
};
